import { defineMessages } from 'react-intl';

export default defineMessages({
	editingDisabled: {
		id: 'cmdb-components.cmdb-object-picker-new.editing-disabled',
		defaultMessage: 'Editing has been disabled for this field',
		description: 'Tooltip explaining why the Assets field editing controls are disabled',
	},
	searchPlaceholder: {
		id: 'cmdb-components.cmdb-object-picker-new.search-placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder text for the search input in the object dropdown',
	},
	showingResults: {
		id: 'cmdb-components.cmdb-object-picker-new.showing-results',
		defaultMessage: 'Showing {displayed} results.',
		description: 'Text showing the number of results currently displayed in the dropdown',
	},
	loadMore: {
		id: 'cmdb-components.cmdb-object-picker-new.load-more',
		defaultMessage: 'Load more',
		description: 'Link text to load more search results in the dropdown list',
	},
	selectFirstResults: {
		id: 'cmdb-components.cmdb-object-picker-new.select-first-results',
		defaultMessage: 'Select first {count} results',
		description: 'Label for the select-all checkbox that selects the first N results',
	},
	selectedCount: {
		id: 'cmdb-components.cmdb-object-picker-new.selected-count',
		defaultMessage: '{count} selected',
		description: 'Text showing the number of currently selected items',
	},
	fieldLimitReached: {
		id: 'cmdb-components.cmdb-object-picker-new.field-limit-reached',
		defaultMessage: 'Field limit reached',
		description: 'Message shown when the maximum number of objects for the field has been reached',
	},
	cancel: {
		id: 'cmdb-components.cmdb-object-picker-new.cancel',
		defaultMessage: 'Cancel',
		description: 'Text for the cancel button to dismiss the dropdown',
	},
	addObjects: {
		id: 'cmdb-components.cmdb-object-picker-new.add-objects',
		defaultMessage: '{count, plural, one {Add # object} other {Add # objects}}',
		description: 'Text for the button that confirms adding the selected objects',
	},
	addObject: {
		id: 'cmdb-components.cmdb-object-picker-new.add-object',
		defaultMessage: 'Add object',
		description: 'Label for the button that opens the object search dropdown',
	},
	addObjectsLabel: {
		id: 'cmdb-components.cmdb-object-picker-new.add-objects-label',
		defaultMessage: 'Add objects',
		description: 'Label for the button that opens the object search dropdown (portal enhancements)',
	},
	removeObject: {
		id: 'cmdb-components.cmdb-object-picker-new.remove-object',
		defaultMessage: 'Remove {objectLabel}',
		description: 'Accessible label for the button that removes a selected object from the field',
	},
	selectObject: {
		id: 'cmdb-components.cmdb-object-picker-new.select-object',
		defaultMessage: 'Select {objectLabel}',
		description: 'Accessible label for the checkbox that selects an object in the dropdown',
	},
	noObjectsAdded: {
		id: 'cmdb-components.cmdb-object-picker-new.no-objects-added',
		defaultMessage: 'No objects added',
		description: 'Empty-state message shown when no objects are selected for the field',
	},
	noResults: {
		id: 'cmdb-components.cmdb-object-picker-new.no-results',
		defaultMessage: 'No results matching your search.',
		description: 'Message shown when the search returns no matching objects',
	},
	loading: {
		id: 'cmdb-components.cmdb-object-picker-new.loading',
		defaultMessage: 'Loading',
		description: 'Accessible label for the loading spinner',
	},
	search: {
		id: 'cmdb-components.cmdb-object-picker-new.search-label',
		defaultMessage: 'Search assets',
		description: 'Accessible label for the search input',
	},
	removeAll: {
		id: 'cmdb-components.cmdb-object-picker-new.remove-all',
		defaultMessage: 'Remove all',
		description: 'Label for the button that removes all selected objects from the field',
	},
	removeOnThisPage: {
		id: 'cmdb-components.cmdb-object-picker-new.remove-on-this-page',
		defaultMessage: 'On this page ({count})',
		description: 'Remove-all menu option that removes the objects shown on the current page',
	},
	removeSearchResults: {
		id: 'cmdb-components.cmdb-object-picker-new.remove-search-results',
		defaultMessage: 'Search results ({count})',
		description: 'Remove-all menu option that removes all objects matching the current search',
	},
	removeAddedObjects: {
		id: 'cmdb-components.cmdb-object-picker-new.remove-added-objects',
		defaultMessage: 'Added objects ({count})',
		description: 'Remove-all menu option that removes all added objects from the field',
	},
	previousPage: {
		id: 'cmdb-components.cmdb-object-picker-new.previous-page',
		defaultMessage: 'Previous',
		description: 'Label for the button that shows the previous page of selected object cards',
	},
	nextPage: {
		id: 'cmdb-components.cmdb-object-picker-new.next-page',
		defaultMessage: 'Next',
		description: 'Label for the button that shows the next page of selected object cards',
	},
	pageIndicator: {
		id: 'cmdb-components.cmdb-object-picker-new.page-indicator',
		defaultMessage: 'Page {current} of {total}',
		description: 'Indicates the current page and total pages of selected object cards',
	},
	pageLabel: {
		id: 'cmdb-components.cmdb-object-picker-new.page-label',
		defaultMessage: 'Page',
		description: 'Accessible label for a page number in the selected objects pagination',
	},
	paginationRangeInline: {
		id: 'cmdb-components.cmdb-object-picker-new.pagination-range-inline',
		defaultMessage: 'Viewing {start}-{end} of {total}',
		description:
			'Shows the range of selected object cards currently visible out of the total count',
	},
	clearSearch: {
		id: 'cmdb-components.cmdb-object-picker-new.clear-search',
		defaultMessage: 'Clear search',
		description: 'Link to clear the added-objects list search and show all objects again',
	},
});
